import { LinearProgress } from '@mui/material';
import createStyles from '@mui/styles/createStyles/createStyles';
import makeStyles from '@mui/styles/makeStyles/makeStyles';
import { DropzoneArea } from 'mui-file-dropzone';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AppState, store, useAppSelector } from 'src/store';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import fileUploadConfigs from './../../configs/documentConfigs';
import DocManagementService from './../service/DocManagementService';
import './DocumentUploadComponent.scss';

export const DocumentUploadComponent = (props: any) => {
  const [disable, setDisable] = useState(false);
  const [addStyle, setAddStyle] = useState('');
  const acceptedFiles = fileUploadConfigs.validUploadFileFormats;
  const dropZoneConfigs = fileUploadConfigs.dropZoneConfigs;
  const { t } = useTranslation();
  const navMenuLocale: any = t('documentUpload', {
    returnObjects: true,
    filesLimit: dropZoneConfigs.filesLimit
  });

  useEffect(() => {
    if (props.isUploaded) {
      if (props.error) {
        props.setStyleUpload('uploadFileError');
      } else {
        props.setStyleUpload('uploadFileSuccess');
      }
    } else {
      props.setStyleUpload('uploadFile');
    }
  }, [props.isUploaded, props.error]);

  useEffect(() => {
    if (!props.site || props.site === '--' || !props?.metaData?.isf_artifact_name) {
      setDisable(true);
      setAddStyle(' noUploadFile');
    } else {
      setDisable(false);
      setAddStyle(' uploadFile');
    }
  }, [props.site, props?.metaData?.isf_artifact_name]);

  const handleFileChange = async (files: any) => {
    if (files && files.length) {
      props.setUploaded(true);
      store.dispatch(
        setSnackbarMessage(
          t('fileUploadSuccess', {
            returnObjects: true,
            fileName: files?.[0]?.name
          }),
          'success'
        )
      );
      props.setFileUploading(true);
      props.setProgress(0);
      props.setError(null);
      props.onFileUploadSuccess(files[0]);
    }
  };

  const useStyles = makeStyles(() =>
    createStyles({
      previewChip: {
        minWidth: 160,
        maxWidth: 210
      }
    })
  );
  const classes = useStyles();

  return (
    <div id="uploadFile" className={`${props.styleUpload}${addStyle} withFakeBtn`}>
      <DropzoneArea
        dropzoneProps={{ disabled: disable }}
        fileObjects={[]}
        showPreviewsInDropzone={props.isUploaded}
        showPreviews={dropZoneConfigs.showPreviews}
        filesLimit={dropZoneConfigs.filesLimit}
        acceptedFiles={acceptedFiles}
        maxFileSize={dropZoneConfigs.maxFileSize}
        useChipsForPreview
        showAlerts={['error', 'info']}
        dropzoneText={
          props.isUploaded
            ? props.isFileUploading
              ? navMenuLocale.fileUploadInitiated
              : props.error
              ? t('fileError', {
                  returnObjects: true
                })
              : navMenuLocale.fileUploadSuccess
            : navMenuLocale.dragDropHere
        }
        previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
        previewChipProps={{ classes: { root: classes.previewChip } }}
        previewText={navMenuLocale.previewText}
        getFileLimitExceedMessage={() => `${navMenuLocale.cannotUploadMore}`}
        onChange={e => handleFileChange(e)}
        getDropRejectMessage={props.handleRejectedMessage}
      />
      {props.isFileUploading && <LinearProgress variant="determinate" value={props.progress} />}
    </div>
  );
};
